import styled from 'styled-components';
import { DividerMixin } from '../../mixins/components/DividerMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledDivider = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['orientation'])
}).withConfig({
  displayName: "StyledDivider",
  componentId: "c11n-8-107-0__sc-1r0esng-0"
})(["", ""], DividerMixin);